{
  "title": "Conjure Animals",
  "source": "Player's Handbook",
  "levelAndSchool": "3rd-level conjuration",
  "level": 3,
  "castingTime": "1 action",
  "range": "60 feet",
  "components": "V, S",
  "duration": "Concentration, up to 1 hour",
  "description": [
    "You summon fey spirits that take the form of beasts and appear in unoccupied spaces that you can see within range.",
    "Choose one of the following options for what appears:",
    "One beast of challenge rating 2 or lower",
    "Two beasts of challenge rating 1 or lower",
    "Four beasts of challenge rating 1/2 or lower",
    "Eight beasts of challenge rating 1/4 or lower",
    "Each beast is also considered fey, and it disappears when it drops to 0 hit points or when the spell ends.",
    "The summoned creatures are friendly to you and your companions. Roll initiative for the summoned creatures as a group, which has its own turns. They obey any verbal commands that you issue to them (no action required by you). If you don’t issue any commands to them, they defend themselves from hostile creatures, but otherwise take no actions. The DM has the creatures’ statistics.",
    "At Higher Levels. When you cast this spell using certain higher-level spell slots, you choose one of the summoning options above, and more creatures appear: twice as many with a 5th-level slot, three times as many with a 7th-level slot, and four times as many with a 9th-level slot."
  ],
  "spellLists": ["druid", "ranger"]
}
